import { AssortmentApiResponse, GetAssortmentResponse } from '../../types/responses';
import { ApiAssortment, ApiAssortmentItem, ApiForecastInfo } from '../../types/api';
import { Product } from '../products/products.types';
import { MetricJob } from '../../types/models';
import { convertAssortment, mergeCurrentStateProduct } from '../../helpers/data';

export const getAssortmentData = (assortmentResponseData: AssortmentApiResponse, assortmentApi: ApiAssortment): GetAssortmentResponse => {
  const res: Record<string, ApiAssortmentItem> = {};
  const processedRes: ApiAssortmentItem[] = [];
  const totalCommitments: Record<string, number> = {};

  const {
    productInfo,
    forecastInfo: forecastInfoApi,
    inventoryInfo,
    locationInfo,
    productInfoNotNormalized,
    metricsProductStoreInfo: metricsProductStoreInfoApi
  } = assortmentResponseData;

  const { productsList } = productInfo;

  assortmentApi.aisle.forEach((e) => {
    if (productsList.includes(e)) {
      res[e] = {} as ApiAssortmentItem;
    }
  });

  [forecastInfoApi, inventoryInfo, locationInfo, productInfoNotNormalized].forEach((d) => {
    d.forEach((item: ApiForecastInfo | ApiAssortmentItem | Product) => {
      if (!(item.product_num in res)) {
        res[item.product_num] = {} as ApiAssortmentItem;
      }

      res[item.product_num] = { ...res[item.product_num], ...item };
      res[item.product_num].sku = item.product_num;
    });
  });

  const { facings, q1f, bincap, wos, fill_trips } = metricsProductStoreInfoApi;

  inventoryInfo.forEach(p => {
    const { product_num, total_item_count } = p;

    if (res[product_num]) {
      res[product_num].total_commitments = total_item_count;
      totalCommitments[product_num] = total_item_count;
    }
  });

  Object.keys(facings).forEach((f) => {
    if (res[f]) {
      res[f].facings = facings[f];
    }
  });

  Object.keys(q1f).forEach((q) => {
    if (res[q]) {
      res[q].q1f = q1f[q];
    }
  });

  Object.keys(bincap).forEach((b) => {
    if (res[b]) {
      res[b].bincap = bincap[b];
    }
  });

  Object.keys(wos).forEach((w) => {
    if (res[w]) {
      res[w].wos = wos[w];
    }
  });

  Object.keys(fill_trips).forEach((f) => {
    if (res[f]) {
      res[f].fill_trips = fill_trips[f];
    }
  });

  Object.keys(res).forEach((e) => {
    processedRes.push(res[e]);
  });

  const currentTotalFacings = Object.values(facings).reduce((acc, val) => acc + val, 0);

  return {
    assortment: processedRes,
    currentTotalFacings,
    metricsProductStoreInfo: metricsProductStoreInfoApi,
    forecastInfo: forecastInfoApi,
    totalCommitments
  };
};

export const getBaseAssortment = (assortmentResponseData: AssortmentApiResponse, currentStateProduct: MetricJob, assortmentApi: ApiAssortment = {} as ApiAssortment) => {
  const { assortment, currentTotalFacings, forecastInfo, metricsProductStoreInfo, totalCommitments } = getAssortmentData(assortmentResponseData, assortmentApi);
  const { cross_merch: crossMerch } = assortmentApi;
  const baseAssortment = mergeCurrentStateProduct(
    assortment.map((p) => convertAssortment(p, crossMerch)),
    currentStateProduct
  );

  const baseAssortmentWithTargetBincap = baseAssortment.map(a => {
    if (['FD', 'DWO'].includes(a.corpStatus)) {
      return {
        ...a,
        minTargetBincap: null,
        maxTargetBincap: a.totalCommitments > 0 ? a.totalCommitments : null
      };
    }

    return a;
  });

  return { assortmentApi, totalCommitments, forecastInfo, baseAssortmentWithTargetBincap, metricsProductStoreInfo, currentTotalFacings };
};
